import { IFilter } from "@/models/tables";
import { FilterOperators, FilterTypes } from "@/data/table";
import { TaxTagTypes, TaxTagTypesMap } from "@/data/enums/tax";
import i18n from "@/i18n";

export const NameFilter: () => IFilter = () => ({
  key: "name",
  label: i18n.t("_.name"),
  type: FilterTypes.STRING,
  operator: FilterOperators.EQUAL,
  group: "tax_tag"
});

export const CreatedAtFilter: () => IFilter = () => ({
  key: "created_at",
  label: i18n.t("_.created_at"),
  type: FilterTypes.DATE,
  operator: FilterOperators.EQUAL,
  group: "tax_tag"
});

export const AmountFilter: () => IFilter = () => ({
  key: "amount",
  label: i18n.t("_.amount"),
  type: FilterTypes.NUMBER,
  operator: FilterOperators.EQUAL,
  group: "tax_tag"
});

export const TypeFilter: () => IFilter = () => ({
  key: "type",
  label: i18n.t("_.type"),
  type: FilterTypes.SELECT_CHECKBOX,
  operator: FilterOperators.EQUAL,
  options: [
    {
      value: `${TaxTagTypes.PERCENT}`,
      label: TaxTagTypesMap()[TaxTagTypes.PERCENT].label.toString()
    },
    {
      value: `${TaxTagTypes.FIXED}`,
      label: TaxTagTypesMap()[TaxTagTypes.FIXED].label.toString()
    }
  ],
  group: "tax_tag"
});

export const DefaultTaxTagFilters: () => IFilter[] = () => [
  NameFilter(),
  CreatedAtFilter(),
  AmountFilter(),
  TypeFilter()
];
